import ApiService from '../../../../../../../resources/app/services/api.js';
import {errorHelper} from "../../../../../../../resources/app/utils/helpers/errorHelper.js";
import {objectHelper} from "../../../../../../../resources/app/utils/helpers/objectHelper.js";

export const auth = {
    namespaced: true,
    state: () => ({
        user: null,
        email: null,
        error: null
    }),
    getters : {
        authUser: (state) => {
            return state.user;
        },
        email: (state) => {
            return state.email;
        },
        error: (state) => {
            return state.error;
        },
        loggedIn: (state) => {
            return !!state.user;
        },
        guest: () => {
            const storageItem = window.localStorage.getItem("guest");
            if (!storageItem) return false;
            if (storageItem === "isGuest") return true;
            if (storageItem === "isNotGuest") return false;
        },
        isCustomer: (state) => {
            if(!objectHelper.isEmptyObject(state.user)) {
                return state.user && state.user.hasOwnProperty('is_customer') ? state.user.is_customer : false;
            }
            return false;
        },
        isCompanyCustomer: (state) => {
            if(!objectHelper.isEmptyObject(state.user)) {
                return state.user.hasOwnProperty('is_main_contact');
            }
            return false;
        },
        isPersonalCustomer: (state) => {
            if(!objectHelper.isEmptyObject(state.user)) {
                return !state.user.hasOwnProperty('is_main_contact');
            }
            return false;
        },
        isMainContact: (state) => {
            if(state.user.hasOwnProperty('is_main_contact')) {
                return state.user.is_main_contact;
            }
            return false;
        },
        isEmployee: (state) => {
            if(state.user.hasOwnProperty('is_employee')) {
                return state.user.is_employee;
            }
            return false;
        },
        isSupplier: (state) => {
            if(state.user.hasOwnProperty('is_supplier')) {
                return state.user.is_supplier;
            }
            return false;
        },
    },
    mutations : {
        setUser(state, user) {
            state.user = user;
        },
        setEmail(state, email) {
            state.email = email;
        },
        setError(state, error) {
            state.error = error;
        }
    },
    actions : {
        async getAuthUser({ commit }) {
            try {
                const response = await ApiService.getAuthUser();
                commit('setUser', response.data.data)
                return response.data.data;
            } catch (error) {
                commit('setError', errorHelper.error(error))
            }
        }
    }
}
